import { Component, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TippyDirective } from '@ngneat/helipopper';

@Component({
  selector: 'app-widget-textarea',
  templateUrl: './textarea.component.html',
  imports: [
    CommonModule,
    FormsModule,
    TippyDirective,
  ]
})
export class WidgetTextareaComponent {

  /**
   * Input id
   */
  id = input('');

  /**
   * Input heading
   */
  heading = input('');

  /**
   * Input value
   */
  value = model();

  /**
   * Input tooltip
   */
  tooltip = input('');
}
